import { createSlice } from '@reduxjs/toolkit'
import { THEMES } from '@/constants'

const initialState = {
  theme: localStorage.getItem('theme') || 'light',
  locale: localStorage.getItem('language') || 'vi',
  sidebarOpen: true,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT
      localStorage.setItem('theme', state.theme)
    },
    setTheme: (state, action) => {
      state.theme = action.payload
      localStorage.setItem('theme', action.payload)
    },
    setLocale: (state, action) => {
      state.locale = action.payload
      localStorage.setItem('language', action.payload)
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload
    }
  }
})

export const {
  toggleTheme,
  setTheme,
  setLocale,
  toggleSidebar,
  setSidebarOpen,
} = uiSlice.actions

// Selectors
export const getTheme = (state) => state.ui.theme
export const getLocale = (state) => state.ui.locale
export const getSidebarOpen = (state) => state.ui.sidebarOpen

export default uiSlice.reducer

